import { render } from "./ViewrMobileResp.vue?vue&type=template&id=0204c412&class=teste"
import script from "./ViewrMobileResp.vue?vue&type=script&lang=js"
export * from "./ViewrMobileResp.vue?vue&type=script&lang=js"

import "./ViewrMobileResp.vue?vue&type=style&index=0&id=0204c412&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__